/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';

import { scrollTo } from '@/utils';
import { globalizationService } from '@/services/globalizationService';
import { memo, useEffect, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation as t } from '../../../../hooks/useTranslation';
import { notificationService } from '../../../../services/notificationService';
import { EpButton } from '../../components';
import QuestionFieldArray from '../../components/EpQuestionFieldArray';

type NotificationCategoriesQuestionsAnswersProps = {
  id: number;
  questionId: number;
  questionDescription: string;
  required: boolean;
  maxLength: number;
  questionReferLibraryId: number;
  questionTypeId: number;
  questionsLibrary: boolean;
  questionCategoryIncident: number;
  order: number;
  answerRequiredId: number | null;
  questionRequiredId: number | null;
  groupId: number | null | undefined;
  answers: {
    answerId: number;
    answerDescription: string;
  }[];
};

const QuestionsAnswers = () => {
  const { setValue, getValues } = useFormContext();
  const tag = 'PSNotificationHow';
  const { translations } = globalizationService.getTranslationsByTag(tag);
  const [OldNotificationCategory, OldNotificationIncident] = useMemo(() => {
    return getValues([
      'notificationCategoryId.inputValue',
      'notificationIncidentId.inputValue',
    ]);
  }, [getValues]);

  const [NotificationCategory, NotificationIncident] = useWatch({
    name: [
      'notificationCategoryId.inputValue',
      'notificationIncidentId.inputValue',
    ],
  });

  const { getNotificationCategoriesQuestionsAnswers } = notificationService;

  const { data: notificationCategoriesQuestionsAnswers }: { data: any } =
    getNotificationCategoriesQuestionsAnswers(
      NotificationCategory,
      NotificationIncident,
    );

  const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));

  const addQuestion = async () => {
    const questions = getValues('questions');
    const groupId = questions[questions.length - 1][0].groupId + 1;
    questions[groupId] = notificationCategoriesQuestionsAnswers.filter(
      (question: any) => {
        if (!question.questionsLibrary) {
          question.groupId = groupId;
          return question;
        }
      },
    );

    setValue('questions', questions);

    await delay(250);

    const questionArrLength = questions?.length;

    scrollTo([`question-${questionArrLength - 1}`]);
  };

  useEffect(() => {
    if (
      notificationCategoriesQuestionsAnswers &&
      notificationCategoriesQuestionsAnswers.length > 0 &&
      (OldNotificationCategory !== NotificationCategory ||
        OldNotificationIncident !== NotificationIncident)
    ) {
      setValue('questions', notificationCategoriesQuestionsAnswers);
    }
  }, [NotificationIncident]);

  useEffect(() => {
    console.table([
      {
        OldNotificationIncident: OldNotificationIncident,
        NotificationIncident: NotificationIncident,
        OldNotificationCategory: OldNotificationCategory,
        NotificationCategory: NotificationCategory,
        notificationCategoriesQuestionsAnswerslength:
          notificationCategoriesQuestionsAnswers?.length,
      },
    ]);
  }, [
    NotificationIncident,
    OldNotificationCategory,
    NotificationCategory,
    OldNotificationIncident,
    notificationCategoriesQuestionsAnswers,
  ]);

  if (
    notificationCategoriesQuestionsAnswers &&
    notificationCategoriesQuestionsAnswers.length > 0
  ) {
    // @TODO - Melhorar lógica
    // não encontrei sentido para esta condicional... testado e ok até o momento.

    if (
      getValues('questions').length > 0 &&
      (!OldNotificationCategory || !OldNotificationIncident) &&
      NotificationCategory !== '4'
    ) {
      return (
        <>
          <QuestionFieldArray />
        </>
      );
    }

    if (
      (OldNotificationCategory !== NotificationCategory ||
        OldNotificationIncident !== NotificationIncident) &&
      OldNotificationCategory !== '4' &&
      NotificationCategory !== '4'
    ) {
      setValue('questions', notificationCategoriesQuestionsAnswers);
    }

    if (
      (OldNotificationCategory !== NotificationCategory ||
        OldNotificationIncident !== NotificationIncident) &&
      (OldNotificationCategory === '4' || NotificationCategory === '4')
    ) {
      return (
        <QuestionsAnswersGroup
          QuestionsAnswers={notificationCategoriesQuestionsAnswers}
        />
      );
    }

    return (
      <>
        <QuestionFieldArray />
        {NotificationCategory === '4' && (
          <EpButton
            buttonType="secondary-outline"
            buttonSize="sm"
            buttonAriaLabel={t(translations, 'Add Drug')}
            buttonLeftIconName="SolidPlus"
            buttonIsFullWidth
            buttonText={t(translations, 'Add Drug')}
            buttonOnClickFunc={() => addQuestion()}
          />
        )}
      </>
    );
  }

  if (
    !notificationCategoriesQuestionsAnswers &&
    NotificationCategory !== '45'
  ) {
    setValue('questions', []);
    return null;
  }
};

const QuestionsAnswersGroup = ({
  QuestionsAnswers,
}: {
  QuestionsAnswers: NotificationCategoriesQuestionsAnswersProps[];
}) => {
  const { setValue, getValues } = useFormContext();
  const tag = 'PSNotificationHow';
  const { translations } = globalizationService.getTranslationsByTag(tag);

  const initilizeQuestions = () => {
    const QuestionsAnswersGroup = QuestionsAnswers.reduce(
      (total: any, question) => {
        if (question.questionsLibrary) {
          total[0] = total[0] ? [...total[0], question] : [question];
        }
        if (!question.questionsLibrary) {
          question.groupId = 1;
          total[1] = total[1] ? [...total[1], question] : [question];
        }
        return total;
      },
      [],
    );

    if (!QuestionsAnswersGroup[0] || QuestionsAnswersGroup[0].length === 0) {
      QuestionsAnswersGroup[0] = QuestionsAnswersGroup[1];
      QuestionsAnswersGroup.pop();
    }

    setValue('questions', QuestionsAnswersGroup);
  };

  useEffect(() => {
    console.log('teste troca conteúdo de questions');
    console.info(`🚀 ~ QuestionsAnswers:`, QuestionsAnswers);
    initilizeQuestions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [QuestionsAnswers]);

  const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));

  const addQuestion = async () => {
    const questions = getValues('questions');
    const groupId = questions[questions.length - 1][0].groupId + 1;
    questions[groupId] = QuestionsAnswers.filter((question) => {
      if (!question.questionsLibrary) {
        question.groupId = groupId;
        return question;
      }
    });

    setValue('questions', questions);

    await delay(250);

    const questionArrLength = questions?.length;

    scrollTo([`question-${questionArrLength - 1}`]);
  };

  return (
    <>
      <QuestionFieldArray />
      <EpButton
        buttonType="secondary-outline"
        buttonSize="sm"
        buttonAriaLabel={t(translations, 'Add Drug')}
        buttonLeftIconName="SolidPlus"
        buttonIsFullWidth
        buttonText={t(translations, 'Add Drug')}
        buttonOnClickFunc={() => addQuestion()}
      />
    </>
  );
};

export default memo(QuestionsAnswers);
